import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class GlobalChangeMapTable extends BasicReactTableWrapper {
  suffix(column) {
    if (column.Header !== "Percentage increase") { return; }

    return "%";
  }

  decimals(column, i) {
    if (i === 2) { return 0; }

    return 2;
  }

  labelColumnIndex(i) {
    return i < 2;
  }

  defaultSorted() {
    return [{ id: "td-2", desc: true }];
  }
}

GlobalChangeMapTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default GlobalChangeMapTable;
